exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.IA_ButtonContainer_1OTcDpDnaWWl_tsYewcVo- {\n\n  width: 100%;\n  display: flex;\n  margin-bottom: 20px;  \n\n}\n\n\n.IA_dropZones_2RjMPMQe_6cOf6ojht_H_J {\n  width: 100%;\n  height: 20px;\n  border: 1px dashed #e0e0e0;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  float: left;\n  position: relative;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_ButtonContainer": "IA_ButtonContainer_1OTcDpDnaWWl_tsYewcVo-",
	"IA_dropZones": "IA_dropZones_2RjMPMQe_6cOf6ojht_H_J"
};